import { Injectable } from '@angular/core';

import * as sdk from '@mycure/sdk';
import { MycureSDK } from '../service';
import * as _ from 'lodash';

import { Logger } from './../logger/logger.service';
const log = new Logger('NotificationService');

@Injectable({
  providedIn: 'root'
})

export class McQueueItemService {

  constructor(
    private sdk: MycureSDK,
  ) {

  }

  /**
   * Create a queue item 
   * @param queueItem - use QueueItemMeta
   */
  async createQueueItem(queueItem: any) {
    return this.sdk.queue.items().create(queueItem);
  }

  async createNewQueueItemAndPx(patient: any, queueItem: any) {
    // if patient is not yet created, create one.
    let createdPx: any;

    // require queue item id
    if (!queueItem.id) throw new Error('queue item missing');  

    if (!patient.id) {
      const details = _.pick(patient, ['name', 'dateOfBirth', 'sex', 'mobileNo']);
      let _patient = _.pick(patient, ['facility']);
      _patient['personalDetails'] = details;
  
      // create px
      createdPx = await this.sdk.mf.patients().create(_patient);    
    } else {
      createdPx = patient;
    }

    // require patient
    if (!createdPx) throw new Error('px cannot create');  

    // update queue item
    const update: any = {
      meta: { 
        patient: createdPx.id, 
        patientMobileNo: undefined, // make sure to update these inputs
      } 
    };
    const createdQItem = await this.sdk.queue.items().update(queueItem.id, update);
    if (!createdQItem) throw new Error('queue cannot create');
    
    return { createdPx, createdQItem };
  }
}
